"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelect = useSelect;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _downshift = require("downshift");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Layer = _interopRequireDefault(require("@commerce-ui/core2/Layer"));
var _SelectInline = require("@commerce-ui/core2/SelectInline");
var _useSelectState = _interopRequireDefault(require("@commerce-ui/core2/useSelectState"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSelect(props) {
  /**
   * we keep a bit different naming:
   * - options
   * - value
   * - onChange
   */

  var selectState = (0, _useSelectState["default"])(props);
  var options = selectState.options,
    value = selectState.value,
    setValue = selectState.setValue;

  // Stateful / Stateless
  var downshiftOptions = {
    items: options,
    selectedItem: value,
    onSelectedItemChange: function onSelectedItemChange(item) {
      setValue(item.selectedItem);
    }
  };
  var downshiftSelect = (0, _downshift.useSelect)(downshiftOptions);
  var buttonPropsDownshift = downshiftSelect.getToggleButtonProps();
  var anchorRef = (0, _react.useRef)(null);
  var buttonRef = function buttonRef(element) {
    buttonPropsDownshift.ref(element);
    anchorRef.current = element;
  };
  var buttonProps = _objectSpread(_objectSpread({}, buttonPropsDownshift), {}, {
    buttonRef: buttonRef
  });
  delete buttonProps.ref;
  var newOptions = options.map(function (option, index) {
    var itemDownshiftProps = downshiftSelect.getItemProps({
      index: index,
      item: option
    });
    itemDownshiftProps._ref = itemDownshiftProps.ref;
    delete itemDownshiftProps.ref;
    return _objectSpread(_objectSpread({}, option), {}, {
      selectableProps: _objectSpread({
        selected: value && option.id === value.id,
        highlighted: downshiftSelect.highlightedIndex === index,
        disabled: !!option.disabled,
        option: option,
        value: option.id,
        key: option.id,
        label: option.label
      }, itemDownshiftProps)
    });
  });
  var layerProps = {
    isOpen: downshiftSelect.isOpen
  };
  return _objectSpread(_objectSpread(_objectSpread({}, downshiftSelect), selectState), {}, {
    // TODO: open, close functions

    options: newOptions,
    menuProps: downshiftSelect.getMenuProps(),
    layerProps: layerProps,
    anchorRef: anchorRef,
    buttonProps: buttonProps
  });
}

/**
 * Select can be styled as 'InputContainer' and also as with a separate custom button.
 * We should clean this up and especially clean up InputContainer concept.
 *
 */
function Select2(props) {
  var label = props.label,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "Select value" : _props$placeholder,
    onClick = props.onClick,
    controller = props.controller,
    button = props.button,
    separator = props.separator,
    selectable = props.selectable,
    width = props.width,
    height = props.height,
    minWidth = props.minWidth,
    minHeight = props.minHeight,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    animationTime = props.animationTime,
    animationEase = props.animationEase,
    backgroundColor = props.backgroundColor,
    root = props.root,
    container = props.container,
    placement = props.placement,
    anchoredTo = props.anchoredTo,
    header = props.header,
    footer = props.footer,
    children = props.children;
  var layerProps = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    animationTime: animationTime,
    animationEase: animationEase,
    backgroundColor: backgroundColor,
    root: root,
    container: container,
    placement: placement,
    anchoredTo: anchoredTo,
    header: header,
    footer: footer
  };
  if (!controller) {
    controller = (0, _useSelectState["default"])(props);
  }
  var _controller = controller,
    buttonProps = _controller.buttonProps,
    menuProps = _controller.menuProps,
    anchorRef = _controller.anchorRef,
    options = _controller.options,
    value = _controller.value,
    isOpen = _controller.isOpen,
    openMenu = _controller.openMenu;
  options = controller.options;

  // TODO: should be possible to make it a function
  // TODO: pass "selected", "disabled", "error", "placehoder", "selectedOption", "selectedValue"
  // const button = React.cloneElement($button, {
  //   ...buttonProps,
  //   sx: { ...$button.props.sx, ...restSx }
  // });

  button = typeof button === "function" ? button(controller) : button;
  return __jsx(_Layer["default"], (0, _extends2["default"])({}, layerProps, {
    button: /*#__PURE__*/_react["default"].cloneElement(button, buttonProps)
  }), function (_ref) {
    var close = _ref.close;
    var items = [];
    var selectableProps = (0, _SelectInline.getSelectableProps)(controller, props, {
      allowUnselect: false
    });
    selectableProps = selectableProps.map(function (props) {
      return _objectSpread(_objectSpread({}, props), {}, {
        onClick: function onClick() {
          props.onClick.apply(props, arguments);
          close();
        }
      });
    });
    if (typeof children === "function") {
      var optionsArg = options.map(function (option, index) {
        return _objectSpread(_objectSpread({}, option), {}, {
          selectableProps: selectableProps[index]
        });
      });
      items = children({
        options: optionsArg
      });
    } else {
      options.forEach(function (option, i) {
        var item = typeof selectable === "function" ? selectable({
          option: option
        }) : selectable;
        items.push(/*#__PURE__*/_react["default"].cloneElement(item, selectableProps[i])); // TODO: we need more flexibility with item look

        if (separator && i < options.length - 1) {
          items.push(/*#__PURE__*/_react["default"].cloneElement(separator, {
            role: "separator",
            key: "separator-" + i
          }));
        }
      });
    }
    return __jsx(_Box["default"], null, items);
  });
}
var _default = Select2;
exports["default"] = _default;